import React, { type ReactNode } from "react";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";
import { type Merge } from "type-fest";
import { css, cx } from "../../styled-system/css";
import { iconButtonStyles } from "../common";

export type PageNumberControllerProperties = Merge<
  React.ComponentProps<"div">,
  {
    children?: never;
    className?: React.ComponentProps<"div">["className"];
    /**
     * **既定のページサイズ**
     *
     * @default `selectablePageSizes[0]`
     */
    defaultValue?: number;
    /**
     * **選択肢のフォーマット関数**
     * 選択肢をどのように表示するかを指定する。
     */
    format?: { (value: number): ReactNode };
    loading?: boolean;
    next?: boolean;
    onNext: { (value: number, event: React.MouseEvent<HTMLButtonElement>): void };
    onPrevious: { (value: number, event: React.MouseEvent<HTMLButtonElement>): void };
    previous?: boolean;
    /** 現在のページサイズ */
    value: number;
  }
>;

export function PageNumberController({
  className,
  defaultValue,
  format,
  loading,
  next = true,
  onNext,
  onPrevious,
  previous = true,
  value,
  ...properties
}: PageNumberControllerProperties) {
  return (
    <div
      {...properties}
      className={cx(css({ alignItems: "center", display: "flex", gap: "8px" }), className)}
    >
      <button
        className={iconButtonStyles({ color: "ghost", size: "40px" })}
        disabled={value === 0 || loading || !previous}
        onClick={function (event) {
          event.preventDefault();
          const newValue = Math.max(Math.round(value) - 1, 0);
          if (newValue !== value) {
            onPrevious(newValue, event);
          }
        }}
      >
        <LuChevronLeft />
      </button>
      <p className={css({ fontSize: "14px", lineHeight: 1 })}>{value + 1}</p>
      <button
        className={iconButtonStyles({ color: "ghost", size: "40px" })}
        disabled={loading || !next}
        onClick={function (event) {
          event.preventDefault();
          const newValue = Math.round(value) + 1;
          if (newValue !== value) {
            onNext(newValue, event);
          }
        }}
      >
        <LuChevronRight />
      </button>
    </div>
  );
}
